import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class SettingController extends BaseController {
  model = DataConst.MODELS.SETTING;
}

export default new SettingController();
